import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateSocialGraph } from "Api/Mutations/Social/invalidateSocialGraph";
import { postSocialBlocks } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Translations/Resources";
import { toast } from "sonner";

/**
 * Blocks a persona (idempotent). Severs both follows and pending follow requests server-side
 * and closes new ones in either direction.
 */
export const useBlockUserMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useResource();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (targetIdentityUserPublicID: string) =>
        postSocialBlocks({ targetIdentityUserPublicID }),
    ),
    onSuccess: () => invalidateSocialGraph(queryClient),
    onError: () => toast.error(t(Resources.Errors.RequestError)),
  });
};
